export function wrapWithMark(
  str: string,
  start: number,
  end: number,
  markId: string
) {
  // 获取字符串的三部分：前缀、中间部分和后缀
  const prefix = str.substring(0, start);
  const middle = str.substring(start, end);
  const suffix = str.substring(end);

  // 将中间部分用 <span> 标签包裹
  const wrappedMiddle = `<mark data-mark-id=${markId} class="bg-[rgba(73,129,242,0.2)]">${middle}</mark>`;

  // 拼接前缀、包裹后的中间部分和后缀
  return prefix + wrappedMiddle + suffix;
}

export function handlePaste(event: ClipboardEvent) {
  console.log("粘贴事件触发");
  event.preventDefault(); // 阻止默认粘贴行为

  // 获取粘贴的纯文本内容
  const text = (event.clipboardData || window.clipboardData).getData("text");

  // 获取当前选区
  const selection = window.getSelection();
  if (!selection?.rangeCount) return;

  // 获取当前选区的范围
  const range = selection.getRangeAt(0);
  range.deleteContents(); // 删除选区内容

  // 创建一个文本节点并插入到范围中
  const textNode = document.createTextNode(text);
  range.insertNode(textNode);

  // 移动光标到文本节点的末尾
  range.setStartAfter(textNode);
  range.setEndAfter(textNode);
  selection.removeAllRanges();
  selection.addRange(range);
}
